import React, { useState, useEffect, useContext } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import styled from "styled-components";
import { PastoralContext } from "./../../../contexts/PastoralContext";
import TimeSlotPicker from "./timeSlotPicker";
import { useNavigate } from "react-router-dom";
import { parseDateSafari, isSafari, safeDateOperation } from "../../../helpers/utils";

const Scheduler = (props) => {
  const {  getFollowUps } = useContext(PastoralContext);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const navigate =useNavigate();
  const [markedDates,setMarkedDates] = useState([]);
  const handleNav = (id) => {
    navigate("/pastoral-care/"+ id,{relative:"route"});
  };
  const isWeekend = date => {
    const day = date.getDay();
    return day === 6 || day === 0; // Disable Saturday (6) and Sunday (0)
  };

  useEffect(() => {
    // Safari detection and warning
    if (isSafari()) {
      console.log('Safari detected - using Safari-compatible date handling');
    }
    
    // Safari-compatible date initialization
    let initialDate;
    if (props.selectedDate) {
      if (props.selectedDate instanceof Date && !isNaN(props.selectedDate)) {
        initialDate = props.selectedDate;
      } else {
        initialDate = parseDateSafari(props.selectedDate);
      }
    } else {
      initialDate = new Date();
    }
    
    setSelectedDate(initialDate);
    props.setUpdatedFollowUpDate && props.setUpdatedFollowUpDate();
    setEvents([]);

    Promise.all([
      getFollowUps("ongoing", "all"),
      getFollowUps("checkin", "all"),
    ])
      .then(([ongoingResult, checkinResult]) => {
        const eventsList = [];
        const markedDatesList = [];

        // Process ongoing follow-ups
        if (ongoingResult && ongoingResult.data && Array.isArray(ongoingResult.data)) {
          ongoingResult.data.forEach((followup) => {
          if (followup.follow_up_date) {
            const eventDate = parseDateSafari(followup.follow_up_date);
            // Validate the parsed date
            if (eventDate && !isNaN(eventDate.getTime())) {
              // Normalize date to midnight for comparison (preserve original for events)
              const normalizedDate = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate());
              markedDatesList.push(normalizedDate);
              const name = `${followup.caller_first_name || ""} ${followup.caller_last_name || ""}`.trim();
              eventsList.push({
                id: followup.id,
                date: eventDate,
                isCheckIn: followup.requires_checkin,
                name: followup.caller_first_name
                  ? followup.caller_first_name
                  : "" +
                    (followup.caller_last_name
                      ? " " + followup.caller_last_name
                      : ""),
                 phone: followup.user_number,
              });
            }
          }
        });
        }

        // Process check-in follow-ups
        if (checkinResult && checkinResult.data && Array.isArray(checkinResult.data)) {
          checkinResult.data.forEach((followup) => {
          if (followup.follow_up_date) {
            const eventDate = parseDateSafari(followup.follow_up_date);
            // Validate the parsed date
            if (eventDate && !isNaN(eventDate.getTime())) {
              // Normalize date to midnight for comparison (preserve original for events)
              const normalizedDate = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate());
              markedDatesList.push(normalizedDate);
              const name = `${followup.caller_first_name || ""} ${followup.caller_last_name || ""}`.trim();
              eventsList.push({
                id: followup.id,
                date: eventDate,
                isCheckIn: followup.requires_checkin,
                name: name || "",
                phone: followup.user_number || followup.caller_phone || "",
              });
            }
          }
        });
        }

        // Remove duplicates from markedDatesList
        const uniqueMarkedDates = markedDatesList.filter((date, index, self) => {
          const dateStr = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
          return index === self.findIndex(d => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}` === dateStr);
        });
        
        setEvents(eventsList);
        setMarkedDates(uniqueMarkedDates);
      })
      .catch((error) => {
        console.error("Error fetching follow-ups:", error);
      });

  }, []);

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };

  const handleTimeChange = (newTime) => {
    props.setUpdatedFollowUpDate(newTime);
  };

  const handleWeekJump = (numberOfWeeks) => {
    var currentDate = new Date(selectedDate); 
    currentDate.setDate( currentDate.getDate()+ numberOfWeeks * 7);
    setSelectedDate(currentDate);
 
  };
  const generateTimeSlots = () => {
    return safeDateOperation(() => {
      const slots = [];
      const baseDate = new Date(selectedDate.getTime()); // Create a copy to avoid mutation
      
      for (let hour = 9; hour < 22; hour++) {
        const time = new Date(baseDate);
        time.setHours(hour, 0, 0, 0);
        slots.push(time);
      }
      return slots;
    }, []);
  };
  //console.log(markedDates)


  // Helper to check if a date is marked
  const isMarked = (date) => {
    if (!date || !markedDates.length) return false;
    
    // Normalize the date to midnight for comparison
    const dateYear = date.getFullYear();
    const dateMonth = date.getMonth();
    const dateDay = date.getDate();
    
    const isMarkedResult = markedDates.some((markedDate) => {
      if (!markedDate || isNaN(markedDate.getTime())) return false;
      
      // Normalize marked date to midnight for comparison
      const markedYear = markedDate.getFullYear();
      const markedMonth = markedDate.getMonth();
      const markedDay = markedDate.getDate();
      
      return (
        dateYear === markedYear &&
        dateMonth === markedMonth &&
        dateDay === markedDay
      );
    });
    
    return isMarkedResult;
  };


  return (
    <Container className="p-3">
      <Title className="pb-3">Day Scheduler</Title>
      <div className="flex flex-col gap-4">
        <div className="grid-cols-2 grid  gap-5">
          <SchedulerContainer>
            <CalendarContainer>
              <EventColumn>
                <EventList>
                  {generateTimeSlots().map((time, index) => (
                    <div className="flex  border-b-2  border-b-moonstone " key={time.getHours()}>
                      <TimeSlot className="text-moonstone" key={index}>
                        {time.getHours()}:00
                      </TimeSlot>
                      <div className="flex flex-column w-full">
                        {events
                          .filter(
                            (event) =>
                              event.date.toDateString() ===
                                selectedDate.toDateString() &&
                              event.date.getHours() === time.getHours()
                          )
                          .map((event, eindex) => (
                            <EventItemContainer key={eindex}>
                              <EventItem
                                className={event.isCheckIn=== 1 ? "check-in" : eindex % 2 === 0 ? "even" : "odd"}
                                style={props.disableEventClick ? { cursor: 'default' } : undefined}
                                onClick={props.disableEventClick ? undefined : () => handleNav(event.id)}
                              >
                                <div className="capitalize">FOLLOW UP - {event.name.toLowerCase()} -  {event.phone} </div>
                              </EventItem>
                            </EventItemContainer>
                          ))}
                      </div>
                    </div>
                  ))}
                </EventList>
              </EventColumn>
            </CalendarContainer>
          </SchedulerContainer>
        <CalendarWrapper>
        <Calendar
          onChange={handleDateChange}
          minDate={props.MinDate ? new Date() : null}
          value={selectedDate?selectedDate:''}
          tileDisabled={({ date, view }) => view === "month" && isWeekend(date)}
          calendarType="gregory"
          className="justify-self-center"
          tileClassName={({ date, view }) => {
            if (view === 'month' && isMarked(date)) {
              return 'highlight';
            }
            return null;
          }}
        />
        </CalendarWrapper>
        </div>
        {props.showTimeSlots && (
          <div className="flex flex-col gap-5 justify-self-center">
             <Button onClick={()=> handleWeekJump (6)}> Six Weeks follow Up</Button>
             <TimeSlotPicker
              selectedDate={selectedDate}
              handleTimeChange={handleTimeChange}
            />
           
          </div>

        )}
      </div>
    </Container>
  );
};

export default Scheduler;

const CalendarWrapper = styled.div`
  /* Safari-specific fixes */
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;

  /* Highlighted dates styling */
  .react-calendar__tile.highlight {
    background: #d9eef0 !important;
    color: #000 !important;
    border-radius: 50% !important;
  }
  
  .react-calendar__tile.highlight:hover {
    background: #c0dde0 !important;
  }
  
  .react-calendar__tile.highlight.react-calendar__tile--active {
    background: #FF7234 !important;
    color: #fff !important;
  }

  /* Safari calendar compatibility */
  .react-calendar {
    -webkit-appearance: none;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .react-calendar__tile {
    -webkit-appearance: none;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  .react-calendar__tile:active {
    background-color: #e6e6e6;
  }

  /* Fix for Safari button styling */
  .react-calendar__navigation button {
    -webkit-appearance: none;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  .react-calendar__navigation button:active {
    background-color: #e6e6e6;
  }
`;

const Container = styled.div`
  background-color: white;
  border-radius: 20px;
`;

const Title = styled.h1`
  color: #00323b;
  font-family: "Space Grotesk";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 4.5px;
`;


const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  &:hover {
    background-color: #0056b3;
  }
`;

const SchedulerContainer = styled.div`
  display: flex;
  max-height: 555px;
`;

const CalendarContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const TimeSlot = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  font-size: 0.8em;
`;

const EventColumn = styled.div`
  flex: 3;
  padding: 10px;
`;

const EventList = styled.div`
  position: relative;
`;

const EventItemContainer = styled.div`
  position: relative;
  width:100%;
`;

const EventItem = styled.div`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  width: 100%;
  height: 24px;
  padding: 9px 19px;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
  cursor:pointer;

  font-family: "Futura PT";
  font-size: 14px;
  font-style: normal;
  font-weight: 450;
  line-height: normal;
  letter-spacing: 3.5px;
  &.check-in {
    border-radius: 0px 20px 20px 0px;
    border: 1px solid #CF3748;
    background: #fff;
    color: #CF3748;
    &:before {
      background-color: #CF3748;
    }
  }
  &.odd {
    border-radius: 0px 20px 20px 0px;
    border: 1px solid #2db3c0;
    background: #fff;
    color: #2db3c0;
    &:before {
      background-color: #2db3c0;
    }
  }
  &.even {
    border-radius: 0px 20px 20px 0px;
    border: 1px solid #ff7234;
    background: #fff;
    color: #ff7234;
    &:before {
      background-color: #ff7234;
    }
  }
  &:before {
    content: "";
    position: absolute;
    left: 0px;
    top: 50%;
    width: 12px;
    height: 24px;
    transform: translateY(-50%);
  }
`;


